import React from 'react'
import moment from 'moment'
import ReactTimeAgo from 'react-timeago'

import { formatTimestamp, timeFormatter } from './TimeService'
import styled from 'styled-components'
import { Tooltip } from '../Tooltip'

interface Props {
  timestamp: number | string | Date
  style?: React.CSSProperties
}

export const TimeAgo: React.FC<Props> = ({ style, timestamp }) => {
  if (!timestamp) {
    return null
  }

  const timestampInMillis = new Date(timestamp).getTime()

  const hoursSinceTimestamp = moment().diff(Number(timestampInMillis), 'hours')
  const formattedTimestampTime = formatTimestamp(Number(timestampInMillis))

  if (hoursSinceTimestamp >= 24) {
    return <TimeWrapper>{formattedTimestampTime}</TimeWrapper>
  }

  return (
    <Tooltip
      title={formattedTimestampTime}
      placement="bottom"
      PopperProps={{ disablePortal: true, style: { zIndex: 90 } }} // To prevent displaying tooltip over page and dock headers
    >
      <TimeWrapper>
        <ReactTimeAgo style={style} date={timestampInMillis} formatter={timeFormatter} title="" />
      </TimeWrapper>
    </Tooltip>
  )
}

const TimeWrapper = styled.div`
  cursor: default;
  display: inline;
`
